import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'slices/user/hooks'
import { Card, CardContent } from 'design-system'
import { ShieldX } from 'lucide-react'

interface PermissionGuardProps {
 permission: string | string[]
 requireAll?: boolean
 children: React.ReactNode
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
 permission,
 requireAll = false,
 children,
}) => {
 const { t } = useTranslation()
 const { hasPermission } = useAuth()

 const perms = Array.isArray(permission) ? permission : [permission]

 const ok = requireAll
 ? perms.every((p) => hasPermission(p))
 : perms.some((p) => hasPermission(p))

 if (ok) {
 return <>{children}</>
 }

 return (
 <div className="flex items-center justify-center min-h-[50vh]">
 <Card className="max-w-md w-full">
 <CardContent className="p-8 text-center">
 <ShieldX className="h-12 w-12 mx-auto text-red-500 mb-4"/>
 <h3 className="text-lg font-semibold mb-2">{t('common.security.permissionDenied')}</h3>
 <p className="text-muted-foreground">
 {t('common.security.insufficientPermission')}
 </p>
 </CardContent>
 </Card>
 </div>
 )
}
